/**
 * @module attribute_filter.transformer
 */
import { attributeValuesToGraphqlFormat } from './employee_attribute.transformer';

/**
 * Transform selectedAttributes from reporting/trends section to expected viarables by current backend.
 *
 * @param {Object} attributes - a set of "attributeId: [attributeValue]" objects
 * @param {number} managerEmployeeIdAttrId
 *
 * @example attributes:
 * {
 *   111: ['val1', 'val2', 'val3'],
 *   222: ['val6', 'val7', 'val8']
 * }
 */
const attributeFilterFrom = (attributes, managerEmployeeIdAttrId) => {
  if (Object.keys(attributes).length === 0) {
    return {
      selectedAttributes: null,
      selectedManagers: null,
    };
  }

  // @ts-expect-error TS(2322): Type 'any' is not assignable to type 'never'.
  const normalAttributes = attributeValuesToGraphqlFormat(attributes, [managerEmployeeIdAttrId]);
  const selectedManagers = attributes[managerEmployeeIdAttrId];

  return {
    selectedAttributes: normalAttributes?.length ? normalAttributes : null,
    selectedManagers: selectedManagers?.length ? selectedManagers : null,
  };
};

export { attributeFilterFrom };
